<template src="./review-dialog.pug" lang="pug"> </template>
<style src="./review-dialog.scss" lang="scss" scoped> </style>

<script>

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';
import { mapState } from 'vuex';

export default {
    mixins: [validationMixin, validate],
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        requestDriverId: {
            type: Number,
            default: null,
            required: true
        }
    },
    data: () => ({
        rejectDialog: false,
        comment: null,
        baseUrl: process.env.VUE_APP_SERVER,
        showPhotoType: true
    }),
    validations: {
        comment: {
            required
        }
    },
    computed: {
        ...mapState({
            images: (state) => state.photoReports.images
        }),
        reviewDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        photoTypeIcon() {
            return this.showPhotoType ? 'speaker_notes_off' : 'speaker_notes';
        },
        photoTypeTitle() {
            const photoTypeText = this.showPhotoType ? 'hidePhotoType' : 'showPhotoType';
            return this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.review.${photoTypeText}`);
        }
    },
    methods: {
        next() {
            this.$refs.carousel.next();
        },

        async acceptPhoto(img) {
            const data = {
                typeId: img.id,
                requestDriverId: this.requestDriverId,
                accept: true
            };

            await this.$store.dispatch('photoReports/changeImage', data);
            this.closeReviewDialog();
        },

        async rejectPhoto(img) {
            if (this.$v.$invalid) {
                this.$v.$touch();
            } else {
                const data = {
                    typeId: img.id,
                    requestDriverId: this.requestDriverId,
                    accept: false,
                    comment: this.comment
                };

                await this.$store.dispatch('photoReports/changeImage', data);
                this.closeRejectDialog();
                this.closeReviewDialog();
            }
        },

        closeRejectDialog() {
            this.$v.$reset();
            this.rejectDialog = false;
            this.comment = null;
        },

        closeReviewDialog() {
            this.next();
            if (!this.images.length) {
                this.reviewDialog = false;
            }
        }
    }
};
</script>
